import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import logo from '../../assets/images/CAMERON (5).png';

interface NavbarProps {
  isScrolled: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ isScrolled }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Referrals', path: '/referrals' },
    { name: 'Contact', path: '/contact' },
  ];
  
  const NavLink: React.FC<{ to: string; children: React.ReactNode }> = ({ to, children }) => (
  <Link to={to} className="text-lg font-medium text-gray-700 hover:text-[#2ab7a9] transition-colors duration-300">
    {children}
  </Link>
);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-primary-DEFAULT/90 backdrop-blur-sm shadow-md' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <nav className="flex items-center justify-between">
          <Link to="/" className="flex items-center bg-transparent">
            <img 
              src={logo} 
              alt="Scott Cameron" 
              className="h-52 w-auto hover:opacity-80 transition-opacity duration-300"
            />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/referrals">Referrals</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </div>
          
          {/* Mobile Navigation Toggle */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-white">
              <Menu size={28} />
            </button>
          </div>
        </nav>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pt-4 pb-4 space-y-4 bg-primary-DEFAULT">
            {navLinks.map((link) => (
              <Link 
                key={link.path}
                to={link.path}
                className={`block py-2 px-4 rounded font-medium transition-colors ${
                  location.pathname === link.path 
                    ? 'bg-primary-dark/20 text-primary-dark' 
                    : 'text-white hover:bg-primary-dark/20'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar; 